import { ENABLE_LOGS } from "./constants";

declare const window: any;

export const log = (message: any, ...optionalParams: any[]) => {
  let logsEnabled = false;

  try {
    logsEnabled = JSON.parse(localStorage.getItem(ENABLE_LOGS) || "false");
  } catch (error) {
    console.log("Unable to enable logs", error);
  }

  if (logsEnabled) {
    console.log(message, ...optionalParams);
  }
};
